import Vue from 'vue';
import { upperFirst } from 'Utils/common';
import {
  SET_ALL,
  SET_NOTIFICATION_LOADING,
  ADD_NOTIFICATIONS_FROM_WS,
  REMOVE_NOTIFICATION,
  SET_NOTIFICATION_AS_READ,
  SET_ALL_NOTIFICATIONS_AS_READ,
  ADD_NOTIFICATIONS_FROM_API,
  LESS_NOTIFICATIONS,
} from './mutation-types';

export default {
  [SET_ALL](state, data) {
    Object.assign(state, data);
    return state;
  },
  [SET_NOTIFICATION_LOADING](state, { channel, loading = true }) {
    const capChannel = upperFirst(channel);
    state[`notification${capChannel}Loading`] = loading;
    return state;
  },
  [ADD_NOTIFICATIONS_FROM_WS](state, { message, channel }) {
    const capChannel = upperFirst(channel);
    const containerName = `notification${capChannel}Data`;
    const newData = state[containerName].concat(message);
    newData.sort((a, b) => {
      const dateA = new Date(a.time);
      const dateB = new Date(b.time);
      return dateB - dateA;
    });
    state[containerName] = newData;
    // Reset click on `Mark All as Read` button
    state[`notification${capChannel}WasSetAsRead`] = false;
    return state;
  },
  [SET_NOTIFICATION_AS_READ](state, { id }) {
    const allNotifications = state.notificationSystemData.concat(state.notificationUpdatesData);
    const itemObject = allNotifications.find(item => item.id === id);
    if (!itemObject || itemObject.read_flag) return state;
    Vue.set(itemObject, 'read_flag', true);
    if (itemObject.channel === 'general-system') {
      state.notificationSystemNew -= 1;
    } else if (itemObject.channel === 'general-updates') {
      state.notificationUpdatesNew -= 1;
    }
    return state;
  },
  [SET_ALL_NOTIFICATIONS_AS_READ](state, { channel }) {
    const capChannel = upperFirst(channel);
    state[`notification${capChannel}Data`].forEach((item) => {
      if (!item.read_flag) {
        Vue.set(item, 'read_flag', true);
      }
    });
    state[`notification${capChannel}New`] = 0;
    return state;
  },
  [ADD_NOTIFICATIONS_FROM_API](state, { data, channel }) {
    const capChannel = upperFirst(channel);
    const containerName = `notification${capChannel}Data`;
    const currentList = state[containerName];
    // filter new list to cut exist notification items
    const filteredNewList = data.filter(newItem => !currentList.some(item => item.id === newItem.id));
    state[containerName] = currentList.concat(filteredNewList);
    state[`notification${capChannel}Loading`] = false;
    return state;
  },
  [REMOVE_NOTIFICATION](state, { itemId, channel }) {
    const capChannel = upperFirst(channel);
    const containerName = `notification${capChannel}Data`;
    state[containerName] = state[containerName].filter(item => item.id !== itemId);
    return state;
  },
  [LESS_NOTIFICATIONS](state, { channel }) {
    const capChannel = upperFirst(channel);
    const containerName = `notification${capChannel}Data`;
    state[containerName] = state[containerName].splice(0, 20);
    return state;
  },
};
